import { render, staticRenderFns } from "./JobApprovalVideoPlayer.vue?vue&type=template&id=86990b60&scoped=true"
import script from "./JobApprovalVideoPlayer.vue?vue&type=script&lang=js"
export * from "./JobApprovalVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./JobApprovalVideoPlayer.vue?vue&type=style&index=0&id=86990b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86990b60",
  null
  
)

export default component.exports